import { groupBy } from 'lodash-es';
import { usePaymentProviderContext } from '../../Session';
import { useShopTokenContext } from '../../Session/ShopTokenContext';
import { useWebshop } from '../webshop';
import { BillingItemType, BillingTableItem } from './types';
import { useBillingQueries } from './useBillingQueries';
import { useEffect } from 'react';
import { useAlerts } from '../../feedback';

export const useBillingPayment = (billingItems: BillingTableItem[]) => {
  const { refetch } = useBillingQueries();
  const { shopToken } = useShopTokenContext();
  const { payBills } = useWebshop();
  const { paymentProvider } = usePaymentProviderContext();
  const { showError } = useAlerts();

  const paymentMethod = paymentProvider?.paymentMethod;

  useEffect(() => {
    if (!paymentMethod) {
      showError('Payment not possible due to missing payment method');
    }
  }, [paymentMethod, showError]);

  if (!paymentMethod) {
    return;
  }

  const { currency, billToContact } = paymentProvider;

  const { invoice: invoices = [], debitMemo: debitMemos = [] } = groupBy(
    billingItems,
    (i) => i.itemType,
  ) as Partial<Record<BillingItemType, BillingTableItem[]>>;

  const message = {
    bearerToken: shopToken?.token ?? '',
    contact: {
      ...billToContact,
      email: billToContact.workEmail,
      address: billToContact.address1,
    },
    currency,
    paymentMethod,
    invoices,
    debitMemos,
  };

  return () => payBills?.(message).then(refetch);
};
